import { PitchDetector } from "../../analyzer/PitchDetector";
import { ICanvasRenderOptions, IDraw2D } from "../abstraction/IDraw2D";
import { IViewLayer } from "../abstraction/IViewLayer";


export class SpectrumDraw implements IDraw2D {

    protected _layer: IViewLayer;
    constructor() {

    }

    attach(layer: IViewLayer) {
        this._layer = layer;
    }

    draw2D(ctx: CanvasRenderingContext2D, options: ICanvasRenderOptions) {

        if (!this.detector)
            return;

        const data = this.detector.freqData; 
        if (!data)
            return;

        let bufferLength = this.detector.getFreqIndex(5000);

        //bufferLength = data.length; 

        ctx.save();
        ctx.resetTransform();
        ctx.globalAlpha = 0.6;

        const barWidth = (ctx.canvas.width / bufferLength) * 2.5;
        let posX = 0;
        for (let i = 0; i < bufferLength; i++) {

            const barHeight = (data[i] + 140) * 2;
            if (i == this.detector.lastFreqIndex)
                ctx.fillStyle = "rgb(50," + Math.floor(barHeight + 100) + ", 50)";
            else 
                ctx.fillStyle = "rgb(" + Math.floor(barHeight + 100) + ", 50, 50)";
            
            ctx.fillRect(
                posX,
                ctx.canvas.height - barHeight / 2,
                barWidth,
                barHeight / 2,
            );
            posX += barWidth + 1;
        }

        ctx.restore();
    }

    detector: PitchDetector;
}